import { useMemo, useSyncExternalStore } from "react";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";

import i18n from "../../i18n";
import { RootState } from "../../state/store";
import { mergeItemOrder, parseItemOrders } from "./dashboardLayout";
import { readStored, subscribeToStored, writeStored } from "./dashboardStorage";

const orderKeyFor = (userId: string) => `dashboardItemOrder:${userId}`;

export const useItemOrder = (scope: string) => {
  const { user } = useSelector((s: RootState) => s.authReducer);
  const { enqueueSnackbar } = useSnackbar();
  const orderKey = user ? orderKeyFor(user.id) : null;
  const stored = useSyncExternalStore(subscribeToStored, () => readStored(orderKey));
  const order = useMemo(() => parseItemOrders(stored)[scope], [stored, scope]);

  const saveShownOrder = (shown: string[]) => {
    if (!orderKey) return;

    const saved = parseItemOrders(readStored(orderKey));
    const orders = { ...saved, [scope]: mergeItemOrder(saved[scope], shown) };
    if (!writeStored(orderKey, JSON.stringify(orders)))
      enqueueSnackbar(i18n.t("dashboard:frame.orderNotSaved"), { variant: "error" });
  };

  return [order, saveShownOrder] as const;
};
